var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcChallengesEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B8B7B7",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.822 56.604h-4.065l-1.44-1.39c5.042-5.866 8.078-13.482 8.078-21.766C67.395 14.974 52.421 0 33.948 0 15.474 0 .5 14.974.5 33.448c0 18.472 14.974 33.447 33.448 33.447 8.284 0 15.9-3.036 21.766-8.079l1.39 1.441v4.065L82.833 90l7.667-7.667-25.678-25.73Zm-30.874 0c-12.813 0-23.156-10.343-23.156-23.156 0-12.813 10.343-23.156 23.156-23.156 12.813 0 23.156 10.343 23.156 23.156 0 12.813-10.343 23.156-23.156 23.156Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.03 19c5.799 0 10.5 4.701 10.5 10.5a10.5 10.5 0 0 1-.576 3.44l5.394 7.703-7.308.024-2.521 6.86-5.272-7.53-.147.002-5.27 7.527-2.522-6.859L19 40.643l5.204-7.432a10.477 10.477 0 0 1-.674-3.711c0-5.799 4.7-10.5 10.5-10.5Zm0 3a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm0 1.5a6 6 0 1 1 0 12 6 6 0 0 1 0-12Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChallengesEmpty);
export default __webpack_public_path__ + "static/media/ic-challenges-empty.742548569fafbfbc8d9992844edfe579.svg";
export { ForwardRef as ReactComponent };